<template>
  <v-row>
    <v-dialog v-model.sync="datailsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>        
        <v-toolbar>
          <v-btn icon @click="$store.dispatch('setDetailsDialog', false)">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalhes da transação</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row>
          <v-col
            xs="12"
            md="4"
          >
            <v-list three-line subheader>
              <v-subheader>Transação</v-subheader>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Produto</v-list-item-title>
                  <v-list-item-subtitle>{{transaction.store.name}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Código da transação</v-list-item-title>
                  <v-list-item-subtitle>{{transaction.platform_id}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Meio de pagamento</v-list-item-title>
                  <v-list-item-subtitle>{{transaction.store.sale_platform.name}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Forma de Pagamento</v-list-item-title>
                  <v-list-item-subtitle>{{transaction.payment.name}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Data da venda</v-list-item-title>
                  <v-list-item-subtitle>
                    Inicio: {{transaction.start_date}}, Fim: {{transaction.finish_date || '-'}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Garantia</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.warranty_left}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Garantia</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.status}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Quantidade</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.qnt}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Valor da venda</v-list-item-title>
                  <v-list-item-subtitle>
                    {{`R$ ${transaction.amount.replace('.',',')}`}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Seu recebimento</v-list-item-title>
                  <v-list-item-subtitle>
                    {{`R$ ${transaction.seller_amount.replace('.',',')}`}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>        
          </v-col>
          <v-col
            xs="12"
            md="4"
            >
            <v-list three-line subheader>
              <v-subheader>Comprador</v-subheader>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Nome</v-list-item-title>
                  <v-list-item-subtitle>{{transaction.subcustomer.name}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Email</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.subcustomer.checkout_email}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>CPF/CNPJ</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.subcustomer.checkout_cpf_cnpj || '-'}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Telefone</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.subcustomer.checkout_phone || '-'}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>CEP</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.subcustomer.address && transaction.subcustomer.address.postal_code || '-'}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Endereço</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.subcustomer.address && transaction.subcustomer.address.address || '-'}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Bairro</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.subcustomer.address && transaction.subcustomer.address.district || '-'}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Cidade/UF</v-list-item-title>
                  <v-list-item-subtitle>
                    {{transaction.subcustomer.address && transaction.subcustomer.address.city.name + '/' +transaction.subcustomer.address.city.state.abbr  || '-'}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col
            xs="12"
            md="4"
            >
            <v-list three-line subheader>
              <v-subheader>Comissões</v-subheader>
              <v-list-item v-for="c in transaction.comissions" :key="c.id">
                <v-list-item-content>
                  <v-list-item-title>{{c.name}}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{`R$ ${c.amount.replace('.',',')}`}}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    data () {
      return {        
      }
    },
    computed: {
      datailsDialog: {
        get() {
          return this.$store.state.detailsDialog;
        },
        set(value) {          
          this.$store.commit('setDetailsDialog', value);
        }
      },
      transaction () {
        return this.$store.state.selectedTransaction;
      }
    }
  }
</script>